import { DEFAULT_EQUIPMENT_TYPE_OPTIONS } from "../../constants";
import { Select } from "../Select";
import { ALL_OPTION } from "./constants";

interface Props {
  onChange: (value: string) => void;
  showAllOption?: boolean;
  defaultValue?: string;
  value?: string;
  customOptions?: EquipmentOption[];
}

export function EquipmentTypeSelect(props: Props) {
  const {
    onChange,
    showAllOption = false,
    defaultValue = "",
    value,
    customOptions,
  } = props;

  let options = DEFAULT_EQUIPMENT_TYPE_OPTIONS;
  if (customOptions) {
    options = customOptions;
  }

  return (
    <Select
      inputLabel="Equipment Type"
      defaultValue={defaultValue ?? ""}
      value={value}
      onChange={onChange}
      options={showAllOption ? ALL_OPTION.concat(options) : options}
      selectProps={{ autoWidth: false }}
    />
  );
}
